<template>
  <div class="design-quality-details">
    <div class="w">
      <div class="title">
        <span class="text" @click="goBack" style="cursor: pointer;"
          >设计品质</span
        >
        <span>
          <img src="../assets/img/dulles/right.png" alt="" />
        </span>
        <span class="text">{{ title }}</span>
      </div>
      <div v-html="content" class="content-html  ql-editor"></div>
    </div>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
export default {
  name: "DesignQualityDetails",
  components: {},
  data() {
    return {
      id: this.$route.query.id || "",
      content: "",
      title: ""
    };
  },
  mounted() {
    this.search();
  },
  watch: {},
  methods: {
    // 查询
    search() {
      this.$http
        .get(`resource/findById`, {
          params: {
            id: this.id
          }
        })
        .then(res => {
          if (res.data.code == "success") {
            // const title = res.data.data.ancestors.split(',')
            // this.ancestors = title[title.length - 1];
            this.title = res.data.data.title;
            this.content = res.data.data.content;
          }
        });
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.design-quality-details {
  min-height: 88vh;
  background: #f2f2f2;
  .title {
    margin: 32px 0;
    font-size: 20px;
    vertical-align: middle;
    img {
      vertical-align: middle;
      margin: 0 10px;
      width: 22px;
    }
    .text {
      vertical-align: middle;
    }
  }
  .content-html {
    margin-bottom: 40px;
  }
}
</style>
